import {Chip as MantineChip, ChipProps} from '@mantine/core';
import {
  AdapterProps,
  FieldAdapter,
} from '../field-factory';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';

export type $ChipAdapterProps = AdapterProps<ChipProps>;

export const $ChipAdapter: FC<FieldAdapter<$ChipAdapterProps>> = ({
  inputProps: {onChange, ...inputProps},
  control,
}) => {
  const {
    field: {value, onChange: fieldOnChange, ...fieldProps},
  } = control;

  const _onChange: ChipProps['onChange'] = (e) => {
    fieldOnChange(e);
    onChange?.(e);
  };

  const {readOnly} = useContext(ReadOnlyContext);

  return (
    <MantineChip
      onChange={_onChange}
      value={value}
      checked={value}
      disabled={readOnly}
      {...fieldProps}
      {...inputProps}
    />
  );
};